if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        if (this.slider && this.slider.zoom) this.slider.zoom.out();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initSlider();
        this.showActiveMedia();
      }

      initSlider() {
        if (this.slider) {
          // Modal was hidden while initialized; recalculate dimensions
          this.slider.update();
          return;
        }

        this.sliderWrapper = this.querySelector('.swiper');
        if (!this.sliderWrapper) return;

        this.slider = new Swiper(this.sliderWrapper, {
          zoom: {
            maxRatio: 3,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'fraction',
          },
          on: {
            slideChange: (swiper) => {
              if (swiper.zoom) swiper.zoom.out();
              window.pauseAllMedia();
            },
          },
        });
      }

      showActiveMedia() {
        if (!this.slider) return;

        const mediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const slides = Array.from(this.sliderWrapper.querySelectorAll('.swiper-slide'));
        const activeSlide = mediaId
          ? this.sliderWrapper.querySelector(`.swiper-slide[data-media-id="${mediaId}"]`)
          : null;
        const activeIndex = activeSlide ? slides.indexOf(activeSlide) : 0;

        this.slider.slideTo(activeIndex, 0);

        if (!activeSlide) return;

        const deferredMedia = activeSlide.querySelector('deferred-media');
        const template = activeSlide.querySelector('template');
        if (deferredMedia && template && template.content.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
